
import { useContext, useEffect, useState } from "react"
import AuthComponent from '../components/AuthComponent'
import AuthLayout from '../components/AuthLayout'
import { ActionTypes, CustomAxiosError, DataProps } from '../utils/types'
import axios from 'axios'
import { notification } from 'antd' 
import { useNavigate, useLocation, useSearchParams } from 'react-router-dom'
import { useAuth } from '../utils/hooks'
import { store } from '../utils/store'
import { UpdatePasswordUrl, ResetPasswordUrl, VerifyTokenUrl } from '../utils/network'


function UpdateUserPassword() {

    const [loading, setLoading] = useState(false) 
    const [errorModal, setErrorModal] = useState<{
        visible: boolean;
        message: string;
    }>({
        visible: false,
        message: ''
    });
    const { state: { updatePasswordUserId }, dispatch } = useContext(store)
    const history = useNavigate()
    const location = useLocation()
    const [searchParams] = useSearchParams()
    const token = searchParams.get('token') || ''
    const initialEmail = location.state?.email || searchParams.get('email') || ''
    const [email, setEmail] = useState(initialEmail)

    useEffect(() => {
        if (!updatePasswordUserId && !token) {
            history("/")
            return
        }

        if (token && !email) {
            axios.get(`${VerifyTokenUrl}?token=${token}`)
                .then(res => {
                    if (res.data?.email) {
                        setEmail(res.data.email)
                    }
                })
                .catch(e => {
                    const errorMsg = e.response?.data?.error || e.response?.data?.detail || e.response?.data?.message || "This password setup link is invalid or expired.";
                    setErrorModal({
                        visible: true,
                        message: errorMsg
                    });
                })
        }
    }, [token, updatePasswordUserId])


    useAuth({
        successCallBack: () => {
            history("/")
        }
    })

    const onSubmit = async (values: DataProps) => {
        if (values["password"] !== values["cpassword"]) {
            setErrorModal({
                visible: true,
                message: "Passwords don't match"
            });
            return
        }
        setLoading(true)
        
        try {
            let response;
            if (token) {
                response = await axios.post(ResetPasswordUrl, { password: values.password, token: token });
            } else {
                response = await axios.post(UpdatePasswordUrl, { ...values, user_id: updatePasswordUserId });
            }

            if (response && response.data) {
                dispatch({
                    type: ActionTypes.UPDATE_PASSWORD_USER_ID,
                    payload: null
                });
                notification.success({
                    message: "Password Set up",
                    description: "Login with the new password"
                });
                history("/login");
            }
        } catch (e: any) {
            console.error("Update password error:", e);
            const errorMsg = e.response?.data?.error || e.response?.data?.detail || e.response?.data?.message || "An error occurred while setting password.";
            setErrorModal({
                visible: true,
                message: errorMsg
            });
        } finally {
            setLoading(false);
        }
    }

    return (
        <AuthLayout>
            <AuthComponent 
                titleText="Create Password"
                titleSpanText=""
                isUpdatePassword={true}
                bottonText="Save"
                linkText="Go back"
                linkPath="/login"
                loading={loading}
                onSubmit={onSubmit}
                hideSignupLink={true}
                initialValues={{ email: email, token: token }}
                isEmailDisabled={!!token || !!email}
                errorMsg={errorModal.visible ? errorModal.message : null}
                onErrorClose={() => setErrorModal({ visible: false, message: '' })}
                modalButtonText="Login"
                onModalButtonClick={() => history('/login')}
            />
        </AuthLayout>
    )

}
export default UpdateUserPassword